import validate from "C:/N41VendorWeb/N41_VENDOR_WEB/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "C:/N41VendorWeb/N41_VENDOR_WEB/src/middleware/01.auth.global.ts";
import manifest_45route_45rule from "C:/N41VendorWeb/N41_VENDOR_WEB/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}